// 航点模式
export default {
    normal: '普通',
    hover: '悬停',
    land: '降落',
    returnStarting: '返航',
    returnHome: '归航',
    parkingInteraction: '停泊交互',
}